import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  headerMessage: {
    defaultMessage: 'Packages',
    id: 'ziBc3k',
    description: 'Packages page header',
  },
  'save-button': {
    defaultMessage: 'Save Changes',
    id: 'HFjIN9',
    description: 'Packages page save button label',
  },
  'saving-button': {
    defaultMessage: 'Saving...',
    id: 'NegeRO',
    description: 'Packages page saving button label',
  },
});

export const tabMessages = defineMessages({
  carrier: {
    defaultMessage: 'Carriers',
    id: 'I7cY5D',
    description: 'Packages page carrier tab label',
  },
  custom: {
    defaultMessage: 'Custom Packages',
    id: 'hH4ahK',
    description: 'Packages page custom tab label',
  },
  sets: {
    defaultMessage: 'Multi-Package Sets',
    id: 'zfhpoK',
    description: 'Packages page package sets tab label',
  },
});
